import React from 'react';
import { useBannerData } from './BannerDataProvider';
import Carousel from './Carousel';

export default function BannersCarousel({ onlyGroup = null }) {
  const bannerData = useBannerData();
  if (!bannerData?.carouselBanners?.length) return null;

  const bannersByGroup = bannerData.carouselBanners.reduce((acc, banner) => {
    const group = banner.carouselGroup ?? 0;
    if (!acc[group]) acc[group] = [];
    acc[group].push(banner);
    return acc;
  }, {});

  let bannersToShow = [];

  if (onlyGroup === null) {
    bannersToShow = [
      ...(bannersByGroup[0] || []),
      ...(bannersByGroup[1] || []),
    ];
  } else if (Array.isArray(onlyGroup)) {
    onlyGroup.forEach((g) => {
      bannersToShow.push(...(bannersByGroup[g] || []));
    });
  } else {
    bannersToShow = bannersByGroup[onlyGroup] || [];
  }

  if (!bannersToShow.length) return null;

  return (
    <div className="xs_bannersCarousel relative mx-2 my-2">
      <Carousel banners={bannersToShow} />
    </div>
  );
}


